import { login, update } from 'features/auth';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    useAcceptPrivacyPolicyMutation
} from 'services/user/user.endpoint';

export const usePrivacyPolicyVM = () => {
    const [isPrivacyPolicyAccepted, setIsPrivacyPolicyAccepted] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [
        acceptPrivacyPolicy,
        {
            isSuccess: acceptPrivacyPolicySuccess,
            data: acceptPrivacyPolicyResponse
        }
    ] = useAcceptPrivacyPolicyMutation();

    const handleAcceptPrivacyPolicy = async () => {
        await acceptPrivacyPolicy(undefined);
    };

    useEffect(() => {
        if (acceptPrivacyPolicySuccess && acceptPrivacyPolicyResponse) {
            dispatch(update(acceptPrivacyPolicyResponse.data));
            navigate('/');
        }
    }, [acceptPrivacyPolicySuccess, acceptPrivacyPolicyResponse, navigate, dispatch]);


    return {
        isPrivacyPolicyAccepted,
        setIsPrivacyPolicyAccepted,
        handleAcceptPrivacyPolicy
    };
};
